const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56 56",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#61B872"
    },
    points: "41,5 15,5 0,5 0,16 56,16 56,5 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#50965C"
    },
    cx: 19,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#50965C"
    },
    cx: 25,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#50965C"
    },
    cx: 31,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#50965C"
    },
    cx: 37,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 16,
    style: {
      fill: "#EDEADA"
    },
    width: 56,
    height: 40
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 21,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 28,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 35,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 42,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 49,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 7,
    cy: 32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 14,
    cy: 32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 21,
    cy: 32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 28,
    cy: 32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 35,
    cy: 32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 42,
    cy: 32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 49,
    cy: 32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 7,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 14,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 21,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 28,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 35,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 42,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 49,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 7,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 14,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 21,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 28,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#424A60"
    },
    cx: 35,
    cy: 47,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8A852"
    },
    d: "M37,0c-1.13,0-2.162,0.391-3,1.025c0.534,0.405,0.979,0.912,1.315,1.495C35.796,2.192,36.376,2,37,2 c1.654,0,3,1.346,3,3s-1.346,3-3,3c-0.553,0-1,0.447-1,1s0.447,1,1,1c2.757,0,5-2.243,5-5S39.757,0,37,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A37F46"
    },
    d: "M32.685,2.52C32.261,3.254,32,4.093,32,5h2C34,3.97,33.478,3.061,32.685,2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A37F46"
    },
    d: "M26.685,2.52C26.261,3.254,26,4.093,26,5h2C28,3.97,27.478,3.061,26.685,2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8A852"
    },
    d: "M35.315,2.52C34.979,1.937,34.534,1.43,34,1.025C33.162,0.391,32.13,0,31,0s-2.162,0.391-3,1.025 c0.534,0.405,0.979,0.912,1.315,1.495C29.796,2.192,30.376,2,31,2s1.204,0.192,1.685,0.52C33.478,3.061,34,3.97,34,5 c0,1.654-1.346,3-3,3c-0.553,0-1,0.447-1,1s0.447,1,1,1c2.757,0,5-2.243,5-5C36,4.093,35.739,3.254,35.315,2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A37F46"
    },
    d: "M20.685,2.52C20.261,3.254,20,4.093,20,5h2C22,3.97,21.478,3.061,20.685,2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8A852"
    },
    d: "M29.315,2.52C28.979,1.937,28.534,1.43,28,1.025C27.162,0.391,26.13,0,25,0s-2.162,0.391-3,1.025 c0.534,0.405,0.979,0.912,1.315,1.495C23.796,2.192,24.376,2,25,2s1.204,0.192,1.685,0.52C27.478,3.061,28,3.97,28,5 c0,1.654-1.346,3-3,3c-0.553,0-1,0.447-1,1s0.447,1,1,1c2.757,0,5-2.243,5-5C30,4.093,29.739,3.254,29.315,2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8A852"
    },
    d: "M23.315,2.52C22.979,1.937,22.534,1.43,22,1.025C21.162,0.391,20.13,0,19,0c-2.757,0-5,2.243-5,5h2 c0-1.654,1.346-3,3-3c0.624,0,1.204,0.192,1.685,0.52C21.478,3.061,22,3.97,22,5c0,1.654-1.346,3-3,3c-0.553,0-1,0.447-1,1 s0.447,1,1,1c2.757,0,5-2.243,5-5C24,4.093,23.739,3.254,23.315,2.52z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.3ce31203df898a6f146243b2471e990f.svg";
export { ForwardRef as ReactComponent };